import { render, staticRenderFns } from "./taskAdd.vue?vue&type=template&id=2aab9ad4&scoped=true&"
import script from "./taskAdd.vue?vue&type=script&lang=js&"
export * from "./taskAdd.vue?vue&type=script&lang=js&"
import style0 from "./taskAdd.vue?vue&type=style&index=0&id=2aab9ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab9ad4",
  null
  
)

export default component.exports